/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";

export const arrowCss = css`
  position: relative;
  width: 9px;
  height: 9px;

  &:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    top: 25%;
    border: 4.5px solid transparent;
    border-top-color: currentColor;
  }
`;
